export default form => {
    const {
        currentValue,
        satisfaction,
        generalComments,
        difficultiesFound,
        rangeId,
        evidence,
        date,
    } = form
    return {
        current_value: currentValue,
        comments: generalComments,
        difficulties: difficultiesFound,
        satisfaction: satisfaction,
        range_id: rangeId,
        evidence,
        date,
    }
}
